import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  mobileNavOpen(event) {
    const drawer = document.querySelector("[data-controller='drawer']");
    if (drawer) {
      const drawerController = this.application.getControllerForElementAndIdentifier(drawer, "drawer");
      drawerController?.openDrawer();
    }
    Turbo.visit("/drawer/mobile_nav", { frame: "active-drawer-content" })
  }
}
